import { conditionalParam as baseConditionalParam, ParamExclusionRule } from '../../utils/ApiUtils';

/**
 * Default exclusion rules for AWIntegrations AGraph/Cloud APIs that reject unknown query params
 */
const AW_INTEGRATIONS_PARAM_EXCLUSION_RULES: ParamExclusionRule[] = [
  {
    urlPrefix: [
      '/partners/models/v1/externalModelReferences:filter',
      '/partners/v1/externalAccountInfos:search',
      '/partners/v1/platforms:exchangeAuthorizationCode',
      '/partners/v1/platforms:filter',
      '/partners/v2/accounts:batchGet',
      'outbound/v1/outboundOperation:send',
    ],
    excludedParams: ['configurationDirectory', 'pkg'],
  },
];

/**
 * Returns the parameter value or undefined if it should be excluded for AWIntegrations endpoints
 * @param url - The API endpoint URL
 * @param paramName - The parameter name
 * @param value - The parameter value
 * @returns The value if not excluded, undefined otherwise
 */
export function conditionalParam<T>(url: string | undefined, paramName: string, value: T): T | undefined {
  return baseConditionalParam(url, paramName, value, AW_INTEGRATIONS_PARAM_EXCLUSION_RULES);
}
